export default {
  computed: {
    productNameWithDevice() {
      const initialProductName = this.product?.name || this.title
      let productName = `${initialProductName || this.$t('loading')}${
        this.deviceName ? ' - ' + this.deviceName : ''
      }`

      if (this.$store.state.storeCode === 'br') {
        if (
          initialProductName?.match('Capinha para celular') &&
          this.deviceName
        ) {
          productName = 'Capinha para celular '
          productName += this.deviceName
          productName += initialProductName.split('Capinha para celular')[1]
        }
      } else if (initialProductName?.match('Phone Case') && this.deviceName) {
        productName = initialProductName.split('Phone Case')[0]
        productName += this.deviceName
        productName += ' Phone Case'
      }
      return productName
    },
  },
}
